import React from "react";
import { Link, useParams } from "react-router-dom";
import { Button, Divider } from "@mui/material";
import { EditOutlined } from "@mui/icons-material";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import EBillProviderBasicDetail from "./EBillProviderComponents/EBillProviderBasicDetail";
import { useGetEBillProviderDetailQuery } from "store/services/eBillProviderApi";
import {
  EBillProviderDetailContext,
  useEBillProviderDetailContext,
} from "contexts/EBillProviderDetailContext";
import EBillProviderDetailTab from "./EBillProviderComponents/EBillProviderDetailTab";

const EBillProviderDetailScreen = () => {
  const { id } = useParams();

  const breadcrumbs = [
    { title: "eBill Providers", path: "/app/crm/ebill-provider/list" },
    { title: "Provider Detail" },
  ];

  const {
    data: eBillProviderDetail,
    isLoading: loadingEBillProvider,
    error,
  } = useGetEBillProviderDetailQuery(id);

  return (
    <EBillProviderDetailContext.Provider
      value={{ eBillProviderDetail, loadingEBillProvider }}
    >
      <BreadcrumbLayout
        breadcrumbs={breadcrumbs}
        isBusy={loadingEBillProvider}
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Error error={error} />

        <BreadcrumbLayout.Paper>
          <EBillProviderBasicDetail />
          <Divider />
          <EBillProviderDetailTab />
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </EBillProviderDetailContext.Provider>
  );
};

export default EBillProviderDetailScreen;

const PageActions = () => {
  const { eBillProviderDetail } = useEBillProviderDetailContext();
  return (
    <div className="flex items-center gap-4">
      <Link to={`/app/crm/ebill-provider/${eBillProviderDetail?._id}/edit`}>
        <Button startIcon={<EditOutlined />} variant="contained">
          Edit
        </Button>
      </Link>
    </div>
  );
};